/**
 * Headless SVG sparkline — stateless, preserves aspect on resize.
 * Expects a non-empty `points` array. Uses the current theme's accent
 * unless color/fill are overridden.
 */
export interface SparklineProps {
  points: number[];
  w?: number;
  h?: number;
  color?: string;
  fill?: string;
  strokeWidth?: number;
}

export function Sparkline({
  points,
  w = 140,
  h = 28,
  color = 'var(--accent)',
  fill = 'var(--accent-soft)',
  strokeWidth = 1.4,
}: SparklineProps) {
  if (points.length < 2) return <svg width={w} height={h} />;

  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;

  const d = points
    .map((p, i) => {
      const x = (i / (points.length - 1)) * w;
      const y = h - ((p - min) / range) * (h - 4) - 2;
      return `${i ? 'L' : 'M'}${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
  const area = `${d} L${w},${h} L0,${h} Z`;

  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden>
      <path d={area} fill={fill} stroke="none" />
      <path d={d} fill="none" stroke={color} strokeWidth={strokeWidth} />
    </svg>
  );
}
